<template>
  <div>
    <div class="text-right pb-1">
      <button
        class="bg-green px-8 py-2 rounded-sm text-white"
        @click="showModal"
      >
        Create New Rule
      </button>
    </div>
    <Table
      ref="ruleTable"
      :endpoint="endpoint"
      :tableConfig="tableConfig"
      class="mt-4"
    />
    <VModal
      name="rule-modal"
      :click-to-close="false"
      width="90%"
      height="98%"
      class="rule-modal"
    >
      <RuleEditor
        :editRuleId="editRuleId"
        @close-modal="closeModal"
        @notification-created="handleNotificationCreation"
      />
    </VModal>
  </div>
</template>

<script>
import RuleEditor from "@/components/Notification/RuleEditor"
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"
import { archiveAutoNotificationRule } from "@/apis/notification/index"

export default {
  components: {
    RuleEditor,
    Table,
  },
  data() {
    return {
      editRuleId: null,
      endpoint: `${siteConfig.siteURL}notifications/auto`,
      tableConfig: [
        {
          header: { textContent: "Status", sortingParam: "status" },
          path: "status",
          classList: "capitalize",
          formatter: status =>
            `<b class="${
              status === "off" ? "text-red" : "text-green"
            }">${status}</b>`,
        },
        {
          header: { textContent: "Updated On", sortingParam: "updated_on" },
          type: "date",
          path: "updated_on",
        },
        {
          header: { textContent: "Trigger" },
          path: "/",
          formatter: rule => {
            if (rule.event_type === "PAYMENT") {
              return "On Payment Success"
            }
            return `${rule.trigger_value} mins before start`
          },
        },
        {
          header: { textContent: "Event" },
          path: "event_type",
          formatter: event_type =>
            `${event_type[0]}${event_type.substr(1).toLowerCase()}`,
        },
        {
          header: { textContent: "Channels" },
          path: "channels",
          classList: "capitalize",
          formatter: channels => channels.join(", "),
        },
        {
          header: { textContent: "Audience" },
          path: "audience.email_in",
          formatter: val => `All ${val}`,
        },
        {
          header: { textContent: "Edit", classList: "text-center" },
          path: "id",
          type: "button",
          classList: "rounded-sm m-0 edit-button",
          buttonText: `Edit`,
          onclick: id => {
            this.editRule(id)
          },
        },
        {
          header: { textContent: "Archive", classList: "text-center" },
          path: "id",
          type: "button",
          classList: "rounded-sm m-0 text-red w-full p-0",
          buttonText: `Archive`,
          onclick: id => {
            this.archiveRule(id)
          },
        },
      ],
    }
  },
  methods: {
    handleNotificationCreation() {
      this.$refs.ruleTable.getItems()
      this.closeModal()
      this.editRuleId = null
    },
    editRule(id) {
      this.editRuleId = id
      this.showModal()
    },
    async archiveRule(id) {
      const v = await this.$swal({
        title: "Archive this notification rule?",
        buttons: ["Cancel", "Archive"],
      })
      if (!v) return

      archiveAutoNotificationRule(id)
        .then(() => {
          this.$noty.info("Auto notification rule archived")
          this.$refs.ruleTable.getItems()
        })
        .catch(err => {
          console.error("Failed to archive auto notification rule.", err)
          this.$noty.error(
            "Failed to archive auto notification rule. Please try again"
          )
        })
    },
    showModal() {
      this.$modal.show("rule-modal")
    },
    closeModal() {
      this.editRuleId = null
      this.$modal.hide("rule-modal")
    },
  },
}
</script>
